import booleanIntersects from '@turf/boolean-intersects';

export const districtsFilter = (activeFilters, item) => {
  if (activeFilters.district.length > 0) {
    if (
      !activeFilters.district.includes(
        item.properties.city_region_id || item.properties.district_id
      )
    )
      return false;
  }
  return true;
};

export const gradientFilter = (activeFilters, item) => {
  if (activeFilters.gradient.length > 0) {
    if (
      !activeFilters.gradient.some((gradient) => {
        const max = gradient.max === 100 ? Infinity : gradient.max;

        if (typeof item.properties.index_main !== 'number') return false;
        return (
          item.properties.index_main >= gradient.min &&
          item.properties.index_main < max
        );
      })
    ) {
      return false;
    }
  }
  return true;
};

export const polygonFilter = (polygons, item) => {
  if (polygons.length > 0) {
    if (!polygons.some((polygon) => booleanIntersects(polygon, item))) {
      return false;
    }
  }
  return true;
};

export const districtPolygonFilter = (district, polygons, item) => {
  if (
    !(
      district.includes(
        item.properties.city_region_id || item.properties.district_id
      ) || polygons.some((polygon) => booleanIntersects(polygon, item))
    )
  ) {
    return false;
  }
  return true;
};
